import {useContext} from 'react';
import {EcommerceDataContext} from "@iscr/xAppLib/context";
import {get_cart_item_count} from "../EcommUtils";
import ShopAccessWrapper from "./ShopAccessWrapper";
import SIcon from "@iscr/views/NUI/StreamlineIcons/SIcon";
import { NavLink } from 'react-router';

const PharmacyButtonWithCartCount = ({onlyShowWhenPopulated = false, active}) => {
    const {cart} = useContext(EcommerceDataContext)
    const items = cart?.items || []

    if(onlyShowWhenPopulated && !items.length) return <></>

    return (
        <ShopAccessWrapper showMessage={true}>
            <NavLink to='/prescription-checkout' id={'cart-icon-button'} className={({ isActive }) => `!text-white flex menu item dropdown focus-visible:ring-1 focus-visible:ring-white rounded-[20px] ${isActive ? "!bg-is2-blue-300 !cursor-default !decoration-transparent" : "bg-transparent"}`}>
                <span className="hidden lg:block">Delivery</span>
                <div className="relative h-9">
                    <SIcon name={'delivery-pill'} cls="p-[9px]" bold svg_cls="h-[18px] w-[18px]" />
                    {!!items.length &&
                        <span
                            className="absolute top-0.5 right-1 inline-flex items-center justify-center w-4 h-4 text-xs font-bold text-white bg-is2-orange rounded-full"
                        >
                            {get_cart_item_count(cart)}
                        </span>
                    }
                </div>
            </NavLink>
        </ShopAccessWrapper>
    )
}
export default PharmacyButtonWithCartCount
